import React from 'react';
import Spinner from './spinner';

export default function QrCodeUploading({
  fileCount,
  handleUploadingQrCodeButton,
}) {
  return (
    <>
      <h3 className="title service-title font-weight-bold mt-5">
        {fileCount} photos are being uploaded from your phone
      </h3>
      <small className="d-block image-loader__qr-code-instructions">
        Please wait while the photos are being transferred
      </small>
      <small className="d-block image-loader__qr-code-instructions">
        This window will close automatically once the upload is complete
      </small>
      <small className="d-block image-loader__qr-code-instructions mb-4">
        <button
          className="btn btn-link btn-sm"
          aria-label="Display QR code"
          role="button"
          onClick={handleUploadingQrCodeButton}>
          Display Qr code
        </button>
      </small>
      <Spinner />
    </>
  );
}
